"use strict";

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyCache = void 0;
/**
 * Storage for static keys of previously connected peers.
 */

var Keycache = /*#__PURE__*/function () {
  function Keycache() {
    _classCallCheck(this, Keycache);

    this.storage = new Map();
  }

  _createClass(Keycache, [{
    key: "store",
    value: function store(peerId, key) {
      this.storage.set(peerId.id, key);
    }
  }, {
    key: "load",
    value: function load(peerId) {
      var _a;

      if (!peerId) {
        return null;
      }

      return (_a = this.storage.get(peerId.id)) !== null && _a !== void 0 ? _a : null;
    }
  }, {
    key: "resetStorage",
    value: function resetStorage() {
      this.storage.clear();
    }
  }]);

  return Keycache;
}();

var KeyCache = new Keycache();
exports.KeyCache = KeyCache;